import React, { useEffect, useState } from 'react';

import Model from '@tripian/model';
import { FormTemplateCompanion, PreLoading, UserCompanions, Button, Notification } from '@tripian/react';

import { TRAVEL_COMPANIONS } from '../../constants/ROUTER_PATH_TITLE';
import useCompanionQuestions from '../../hooks/useQuestionCompanion';
import useCompanion from '../../hooks/useCompanion';

import './TravelCompanions.scss';
import AppNav from '../../App/AppNav/AppNav';

const initialCompanionRequestState: Model.CompanionRequest = { age: 1, name: '', answers: [], title: 'Family member' };

const TravelCompanions = () => {
  // local state
  const [showWarningMessage, setShowWarningMessage] = useState<boolean>(false);
  const [userCompanionState, setUserCompanionState] = useState<Model.CompanionRequest>(initialCompanionRequestState);

  // custom hooks
  const { questionsCompanion, loadingQuestionsCompanion } = useCompanionQuestions();
  const { loadingCompanions, companionsFetch, companions, companionAdd, companionDelete, companionUpdate, loadingCompanionAdd, companionUpdateLoadingList, companionDeleteLoadingList } = useCompanion();

  document.title = TRAVEL_COMPANIONS.TITLE;

  useEffect(() => {
    companionsFetch();
  }, [companionsFetch]);

  const isDoneButtonDisabled = !userCompanionState.name.trim() || !userCompanionState.age;

  if (loadingQuestionsCompanion || loadingCompanions) {
    return (
      <>
        <AppNav header={TRAVEL_COMPANIONS.HEADER} />
        <PreLoading bgColor="rgba(238, 238, 238, 0.8)" />
      </>
    );
  }
  return (
    <>
      <AppNav header={TRAVEL_COMPANIONS.HEADER} />
      <div className="container pt8">
        <div className="row">
          <div className="col col12 travel-companions-form-wrapper">
            {loadingCompanionAdd ? (
              <div className="travel-companions-form-loading">
                <PreLoading bgColor="rgba(238, 238, 238, 0.8)" />
              </div>
            ) : null}
            {/** TODO Add companion, Edit companion forms split */}
            <FormTemplateCompanion
              userCompanion={userCompanionState as Model.Companion}
              questions={questionsCompanion || []}
              callbackFormTemplateCompanion={(userCompanion) => {
                setUserCompanionState(userCompanion);
              }}
            />
            <div className="center">
              <Button
                text="Done"
                color={isDoneButtonDisabled ? 'disabled' : 'primary'}
                disabled={isDoneButtonDisabled}
                onClick={() => {
                  companionAdd(userCompanionState);
                  setUserCompanionState(initialCompanionRequestState);
                }}
              />
            </div>
          </div>
          <div className="col col12 travel-companions-form-wrapper">
            <UserCompanions
              companions={companions || []}
              questions={questionsCompanion || []}
              companionLoadingList={companionUpdateLoadingList.concat(companionDeleteLoadingList)}
              deleteCompanion={(companionId) => {
                companionDelete(companionId);
              }}
              editCompanion={(companion) => {
                /** TODO Companion callback model diff
                 * @Ahmet
                 */
                companionUpdate(companion);
              }}
              showWarningMessage={(show) => {
                setShowWarningMessage(show);
              }}
            />
          </div>
        </div>
      </div>
      {showWarningMessage ? (
        <Notification
          type="warning"
          positionX="center"
          positionY="top"
          title="Change companion warning"
          message="This companion is attached on a trip , You can't make any changes."
          onClose={() => {
            setShowWarningMessage(false);
          }}
          closeMs={3500}
        />
      ) : null}
    </>
  );
};

export default TravelCompanions;
